/**
 * Agent configuration for the Ask Navi stateless copilot agent.
 * Lives in this lib only — swap values when CI-5476 delivers the production agent ARN/payload.
 */
export const ASK_NAVI_AGENT_CONFIG = {
  agentIdentifier: 'brightnav:content:default',
  namespaceId: 'brightnav',
  agentId: 'content',
  agentAliasId: 'default',
};

/** Metadata shape stored on conversational BTM list items. */
export const ASK_NAVI_CONVERSATION_METADATA = {
  agent_identifier: ASK_NAVI_AGENT_CONFIG.agentIdentifier,
};
